import React, { useEffect, useState } from "react";
import { projectsData, projectsNav } from "./Data";
import WorkItems from "./WorkItems";

const Works = () => {
  const [item, setItem] = useState(() => {
    const defaultCategory = projectsNav.find(
      (nav) => nav.name.toLowerCase() === "showcase",
    );
    return defaultCategory
      ? { name: defaultCategory.name.toLowerCase() }
      : { name: "all" };
  });
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(1);

  useEffect(() => {
    if (item.name === "all") {
      setProjects(projectsData);
    } else {
      const filteredProjects = projectsData.filter((project) =>
        project.category.map((cat) => cat.toLowerCase()).includes(item.name),
      );
      setProjects(filteredProjects);
    }
  }, [item]);

  const handleClick = (e, index) => {
    const categoryName = e.target.textContent.toLowerCase();
    setItem({ name: categoryName });
    setActive(index);
  };

  return (
    <div>
      <div className="work__filters">
        {projectsNav.map((item, index) => {
          return (
            <span
              onClick={(e) => {
                handleClick(e, index);
              }}
              className={`${active === index ? "active-work" : ""} work__item`}
              key={index}
            >
              {item.name}
            </span>
          );
        })}
      </div>
      <div className="work__container container grid">
        {projects.map((item) => {
          return <WorkItems item={item} key={item.id} />;
        })}
      </div>
    </div>
  );
};

export default Works;
